import React from 'react'

const MIN = 1
const MAX = 100

// Dual-handle range slider for the age filter on web: drag the two handles to
// set the minimum and maximum age. Returns the range as [minStr, maxStr] to
// match `filters.ageRange`. The handle styling needs pseudo-elements, so it is
// injected once via a <style> tag (inline styles can't target ::thumb).
const THUMB_CSS = `
.kt-age-range {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 24px;
  margin: 0;
  background: none;
  pointer-events: none;
  -webkit-appearance: none;
  appearance: none;
}
.kt-age-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  pointer-events: auto;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #1b3a6b;
  border: 2px solid #ffffff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.3);
  cursor: pointer;
  margin-top: -8px;
}
.kt-age-range::-moz-range-thumb {
  pointer-events: auto;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #1b3a6b;
  border: 2px solid #ffffff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.3);
  cursor: pointer;
}
.kt-age-range::-webkit-slider-runnable-track { background: transparent; height: 4px; }
.kt-age-range::-moz-range-track { background: transparent; height: 4px; }
`

type Props = {
  value?: [string, string]
  onChange: (value: [string, string]) => void
}

export const AgeRangeSlider: React.FC<Props> = ({ value, onChange }) => {
  const minVal = value?.[0] ? Number(value[0]) : MIN
  const maxVal = value?.[1] ? Number(value[1]) : MAX

  const pct = (v: number) => ((v - MIN) / (MAX - MIN)) * 100

  const handleMin = (raw: number) => {
    const next = Math.min(raw, maxVal - 1)
    onChange([String(next), String(maxVal)])
  }
  const handleMax = (raw: number) => {
    const next = Math.max(raw, minVal + 1)
    onChange([String(minVal), String(next)])
  }

  return (
    <div style={{ width: '100%', paddingTop: 4 }}>
      <style>{THUMB_CSS}</style>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
        <span style={{ fontSize: 13, color: '#1b3a6b', fontWeight: 600 }}>{minVal} ans</span>
        <span style={{ fontSize: 13, color: '#1b3a6b', fontWeight: 600 }}>{maxVal} ans</span>
      </div>
      <div style={{ position: 'relative', height: 24 }}>
        {/* full track */}
        <div
          style={{
            position: 'absolute',
            top: 10,
            left: 0,
            right: 0,
            height: 4,
            background: '#e0e0e0',
            borderRadius: 2,
          }}
        />
        {/* selected range */}
        <div
          style={{
            position: 'absolute',
            top: 10,
            left: `${pct(minVal)}%`,
            right: `${100 - pct(maxVal)}%`,
            height: 4,
            background: '#1b3a6b',
            borderRadius: 2,
          }}
        />
        <input
          className="kt-age-range"
          type="range"
          min={MIN}
          max={MAX}
          value={minVal}
          aria-label="Âge minimum"
          onChange={(e) => handleMin(Number(e.target.value))}
        />
        <input
          className="kt-age-range"
          type="range"
          min={MIN}
          max={MAX}
          value={maxVal}
          aria-label="Âge maximum"
          onChange={(e) => handleMax(Number(e.target.value))}
        />
      </div>
    </div>
  )
}

export default AgeRangeSlider
